import React, { Component } from "react"
import I18n from "../../utils/i18n.js"
import ReactDOM from "react-dom"
import AccommodationsMaps from '../../accommodations/apple_maps'
import FavoritesForm from '../../accommodations/favorites_form'
import AccommodationsList from '../../accommodations/list'
import createReactClass from 'create-react-class'
export default createReactClass({
  getDefaultProps() {
    return {
      options: {},
      map: null
    };
  },

  hasWindow() {
    return typeof window !== 'undefined' && window !== null
  },

  renderMaps() {
    return <div className="overview__map">
      {this.hasWindow() ? <AccommodationsMaps
      setInitialMapState={(_) => null}
      map_state={null}
      ref="overview__map"
      setZoom={(_) => null}
      default_bounds={this.props.map_options ? this.props.map_options.default_bounds : null}
      highlightedAccommodation={this.state.highlightedAccommodation}
      setBounds={() => null}
      clusters={this.state.clusters.results}
      getMapsSnippetLink={(accommodation) => this.props.options.base_advert_url.replace('1', accommodation.id)}
      setMapState={(map_state) => this.setState({map_state})}
      setInitialMapStateIsDefault={(_) => null}
      className='overview__mapmap'
    /> : ''}</div>
  },

  getInitialState() {
    return {
      accommodations: this.props.accommodations,
      clusters: [],
      map_visible: true,
    };
  },
  componentWillMount() {
    return I18n.locale = this.props.locale;
  },

  componentDidUpdate(prevProps, prevState) {
    const map_state_eq = _.isEqual(this.state.map_state, prevState.map_state);
    const accommodations_eq = _.isEqual(this.state.accommodations, prevState.accommodations);
    if (!map_state_eq || !accommodations_eq) {
      this.updateClusters();
    }
  },

  updateClusters() {
    const self = this;
    let url = this.props.options.maps_url;
    url += `?zoom=${this.state.map_state.zoom}`;

    if (this.filtered_request) { this.filtered_request.abort(); }
    return this.filtered_request = $.ajax({
      url,
      dataType: 'json',
      success(data) {
        return self.setState({clusters: data, highlightedAccommodation: null});
      }
    });
  },

  toggleForm() {
    return $("#send_to_a_friend_form").toggle();
  },

  favoriteToggled(accommodation, domnode) {
    const self = this;
    return $(domnode).animate({opacity: 0}, 1000, () => self.setState({accommodations: _.without(self.state.accommodations, accommodation)}));
  },

  highlightFavorite(accomodation) {
    const self = this;
    return setTimeout(() => self.setState({highlightedAccommodation: accomodation})
    , 500);
  },

  render() {
    let intro_text;
    if (this.state.accommodations.length === 0) {
      intro_text = I18n.t('favorites.no_favorites');
    } else {
      intro_text = <a href='#' className='btn-link' onClick={this.toggleForm}>{I18n.t('favorites.send_to_a_friend.button')}</a>;
    }

    return <div className="overview">
      {this.renderMaps()}
      <div className="overview__list">
        <div className="overview__intro overview__intro-favorites">
          <h1 className="page-section__title">{I18n.t('favorites.title')}</h1>
          <p>{intro_text}</p>
          <FavoritesForm
            friend_form={this.props.friend_form}
            display_form={this.props.display_form}
          />
        </div>
        <div>
          <AccommodationsList
            favoriting={true}
            favoriteToggled={this.favoriteToggled}
            accommodations={this.state.accommodations}
            onAccommodationChange={this.highlightFavorite}
          />
        </div>
      </div>
    </div>;
  }
});
